<script setup>
  import { ref, onMounted, getCurrentInstance } from 'vue'
  import { useRouter } from 'vue-router'
  import {usePageLoadingStore} from "../../../../../stores/pageLoading";
  import mypageProposalService from "../../../services/mypage/mypageProposalService";
  import KSASecondaryButton from "../../../../../components/ui-components/button/KSASecondaryButton.vue";
  import KSATextButton from "../../../../../components/ui-components/button/KSATextButton.vue";
  import MyPageResumeModal from "../../../components/modal/mypage/MyPageResumeModal.vue";
  import { useAlertStore } from "../../../../../stores/alertStore";
  import SearchResidenceModal from "@/pages/user/components/modal/matching/SearchResidenceModal.vue";
  import SearchLectureCompletionModal from "@/pages/user/components/modal/matching/SearchLectureCompletionModal.vue";
  const { $alert, $confirm } = useAlertStore();

  const globals = getCurrentInstance().appContext.config.globalProperties;
  const { $toast, $pageListBoardNo } = globals;

  const searchMonths = ref(globals.$searchMonths)
  const data_interests = ref(globals.$interests)
  const data_schoolGb = ref(globals.$schoolGb)
  const data_eduTenureGb = ref(globals.$eduTenureGb)
  const data_majorGb = ref(globals.$majorGb)

  const router = useRouter()
  const loadingStore = usePageLoadingStore()

  onMounted(()=>{
    retrieveList()
  })

  const userMatchingResumeModal = ref(null);
  const searchResidenceModal = ref(null) // 지역 선택 모달
  const searchLectureCompletionModal = ref(null) // 수료 강의 선택 모달
  const searchLectureSelections = ref([]) // 선택 수료 강의 상세정보(중복 강의 구분용)

  // 전공계열(주전공) 펼침/닫힘
  const spreadMajorGbClass = ref('min');

  const interestGbListRef = ref(null)
  const schoolGbListRef = ref(null)
  const eduTenureGbListRef = ref(null)
  const majorGbListRef = ref(null)
  const list = ref([])
  const currentPage = ref(1);
  const pageSize = ref(30);
  const totalPages = ref(1);
  const totalCount = ref(0);
  const searchOpen = ref(true)
  const datepickerTermsRef = ref(null);

  const initialSearchInput = {
    searchMonthType: 0, // 변경일
    searchResidences: [], //거주 지역
    searchInterests: data_interests.value.map(item => item.value), // 관심 카테고리
    searchSchoolGbs: data_schoolGb.value.map(item => item.value), // 최종학력
    searchEduTenureGbs: data_eduTenureGb.value.map(item => item.value), // 최종학력 상태
    searchMajorGbs: data_majorGb.value.map(item => item.value), // 전공계열(주전공)
    searchFinLectures: [], // 아카데미 수료 강의
  };
  const searchInput = ref({ ...initialSearchInput });

  const pageSizeGroup = ref([
    { label:"30개씩 보기", value: "30" },
    { label:"50개씩 보기", value: "50" },
    { label:"100개씩 보기", value: "100" },
  ])

  const getParamObj = () => {
    return {
      searchMonths: searchInput.value.searchMonthType,
      searchResidences: searchInput?.value.searchResidences?.join(',') || "",
      searchInterests: searchInput?.value.searchInterests?.join(',') || "",
      searchSchoolGbs: searchInput?.value.searchSchoolGbs?.join(',') || "",
      searchEduTenureGbs: searchInput?.value.searchEduTenureGbs?.join(',') || "",
      searchMajorGbs: searchInput?.value.searchMajorGbs?.join(',') || "",
      searchFinLectures: searchInput?.value.searchFinLectures?.join(',') || "",
      pageNumber: currentPage.value || 0,
      size: pageSize.value || 30,
    };
  }

  // 조건에 맞는 데이터 불러오는 함수
  const retrieveList = () => {
    let paramObj = getParamObj();
    loadingStore.loading = true;
    mypageProposalService.retrieveSearchResumeList(paramObj)
        .then( async (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            // console.log(result);
            totalPages.value = result.totalPages;
            totalCount.value = result.totalElements;
            list.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
          } else {
          }
        }).catch( (res) =>  {
          $alert(["데이터를 받아오지 못했습니다.기업코드 등록여부를 확인해주세요."]);
          console.log( res );
          loadingStore.loading = false;
        });
  }

  // 페이지당 개수 변경
  const onSelectPageSize = (option) => {
    pageSize.value = option.value;
    currentPage.value = 1;
    retrieveList();
  }

  // 페이지 클릭
  const onSelectPage = (pageNo) => {
    currentPage.value = pageNo;
    retrieveList();
  }

  // 검색 버튼
  const onClickSearch = () => {
    currentPage.value = 1;
    retrieveList();
  }

  // 초기화 버튼
  const onClickClearSearchInput = () => {
    Object.assign(searchInput.value, initialSearchInput);
    searchLectureSelections.value = [];

    if (datepickerTermsRef.value && typeof datepickerTermsRef.value.initDates === 'function') {
      datepickerTermsRef.value.initDates();
    }
    if (interestGbListRef.value && interestGbListRef.value.initOptions) {
      interestGbListRef.value.initOptions();
    }
    if (schoolGbListRef.value && schoolGbListRef.value.initOptions) {
      schoolGbListRef.value.initOptions();
    }
    if (eduTenureGbListRef.value && eduTenureGbListRef.value.initOptions) {
      eduTenureGbListRef.value.initOptions();
    }
    if (majorGbListRef.value && majorGbListRef.value.initOptions) {
      majorGbListRef.value.initOptions();
    }
  }

  // 채용 제안
  const onClickResumeCorpYn = async (resumeId) => {
    const ok = await $confirm(["지원자에게 채용을 제안할까요?"], "채용 제안");
    if(!ok) {
      return -1;
    } else {
      let paramObj2 = {
        resumeId: resumeId,
      }
      mypageProposalService.createResumeCorporationByResumeId(paramObj2)
          .then( (res) => {
            loadingStore.loading = false;
            if(res.data.code.toLowerCase() === 'success') {
              //const result = res.data.result;
              $alert("채용을 제안하였습니다.");
              //$toast('', "채용을 제안하였습니다.")
              retrieveList();
            } else {
              $alert("제안을 실패하였습니다.");
              console.log(res);
            }
          }).catch( (res) =>  {
            loadingStore.loading = false;
            $alert("제안을 실패하였습니다.");
            console.log(res);
          });
    }
  }

  // 관심 인재
  const onClickResumeLikeYn = async (resumeId, yn) => {
    let ok;
    if(yn === 1) {
      ok = await $confirm(["관심인재를 삭제하시겠습니까?"], "관심인재 삭제");
    } else {
      ok = await $confirm(["관심인재를 등록하시겠습니까?"], "관심인재 등록");
    }
    if(!ok) {
      return -1;
    } else {
      let paramObj3 = {
        resumeId: resumeId,
        likeState: yn,
      }
      mypageProposalService.changeResumeLikeByResumeId(paramObj3)
          .then( (res) => {
            loadingStore.loading = false;
            if(res.data.code.toLowerCase() === 'success') {
              //const result = res.data.result;
              $alert("변경하였습니다.");
              //$toast('', msg+"을(를) 하였습니다.")
              retrieveList();
            } else {
              $alert("변경을 실패하였습니다.");
              console.log(res);
            }
          }).catch( (res) =>  {
            loadingStore.loading = false;
            $alert("변경을 실패하였습니다.");
            console.log(res);
          });
    }
  }

  // 채용 이력서 보기
  const onClickViewResume = async (resumeId, resumeCorpYn, resumeLikeYn) => {
    // alert("이력서 보기 : " + resumeId);
    userMatchingResumeModal.value.init(false, true, resumeCorpYn, resumeLikeYn);
    userMatchingResumeModal.value.retrieveUserMatchingResumeDetail(resumeId, 1);
    const res = await userMatchingResumeModal.value.show();
    if(!res) {
      retrieveList();
    }
  }


  // 검색 - 지역 선택 - 모달 띄우기
  const showSearchResidenceModal = () => {
    searchResidenceModal.value.show(searchInput.value.searchResidences);
  }

  // 검색 - 지역 선택 - 자식 컴포넌트에서 데이터 수신
  const handleSelectionSubmit = (selectedResult) => {
    searchInput.value.searchResidences = selectedResult;
  };

  // 검색 - 지역 선택 - 선택 지역 삭제
  const deleteResidence = (residence) => {
    searchInput.value.searchResidences = searchInput.value.searchResidences.filter(
        (item) => item !== residence
    );
  };

  // 검색 - 전공계열(주전공) 펼침/닫힘
  const spreadMajorGb = () => {
    spreadMajorGbClass.value = spreadMajorGbClass.value === 'min' ? '' : 'min'
  }

  // 검색 - 아카데미 수료 강의 - 모달 띄우기
  const showSearchLectureCompletionModal = () => {
    const initialSelection = searchLectureSelections.value;
    searchLectureCompletionModal.value.show(initialSelection);
  }

  // 검색 - 아카데미 수료 강의 - 자식 컴포넌트에서 데이터 수신
  const handleLectureSelectionSubmit = (payload) => {
    if (Array.isArray(payload)) {
      searchInput.value.searchFinLectures = [];
      searchLectureSelections.value = payload.map((name, index) => ({
        key: `name:${name}:${index}`,
        lectName: name,
        lectId: null,
      }));
      return;
    }

    searchLectureSelections.value = payload?.selectedLectures || [];
    searchInput.value.searchFinLectures = searchLectureSelections.value
        .map((lecture) => lecture.lectId)
        .filter((lectId) => lectId !== null && lectId !== undefined && lectId !== "");
  };

  // 검색 - 아카데미 수료 강의 - 선택 강의 삭제
  const deleteLecture = (index) => {
    searchLectureSelections.value = searchLectureSelections.value.filter((_, itemIndex) => itemIndex !== index);
    searchInput.value.searchFinLectures = searchLectureSelections.value
        .map((lecture) => lecture.lectId)
        .filter((lectId) => lectId !== null && lectId !== undefined && lectId !== "");
  };
</script>
<!-- MailSMSHistoryView.vue 참고-->
<template>
  <div>
    <div class="filter-wrap" :class="{'open': searchOpen}">
      <p @click="searchOpen = !searchOpen">검색</p>
      <div class="filter">
        <dl>
          <dt>변경일</dt>
          <dd>
            <template v-for="group in searchMonths">
              <KSARadioButton class="mr-md" name="searchMonthGb" :label="group.label" v-model="searchInput.searchMonthType" :value="group.value" />
            </template>
          </dd>
        </dl>
        <dl>
          <dt>거주 지역</dt>
          <dd class="residence-selected">
            <button @click="showSearchResidenceModal()"><i>+</i>지역 선택</button>
            <span v-for="option in searchInput.searchResidences" :key="option">
                {{ option }}<i @click="deleteResidence(option)">삭제</i>
            </span>
          </dd>
        </dl>
        <dl>
          <dt>관심 카테고리</dt>
          <dd>
            <KSACheckBoxGroup
                ref="interestGbListRef"
                className="mr-md"
                name="searchInterests"
                v-model="searchInput.searchInterests"
                :options="data_interests" />
          </dd>
        </dl>
        <dl>
          <dt>최종학력</dt>
          <dd>
            <KSACheckBoxGroup
                ref="schoolGbListRef"
                className="mr-md"
                name="searchSchoolGbs"
                v-model="searchInput.searchSchoolGbs"
                :options="data_schoolGb" />
          </dd>
        </dl>
        <dl>
          <dt>최종학력 상태</dt>
          <dd>
            <KSACheckBoxGroup
                ref="eduTenureGbListRef"
                className="mr-md"
                name="searchEduTenureGbs"
                v-model="searchInput.searchEduTenureGbs"
                :options="data_eduTenureGb" />
          </dd>
        </dl>
        <dl style="align-items: start;">
          <dt>전공계열(주전공)</dt>
          <dd class="majorGb" :class="spreadMajorGbClass">
            <button @click="spreadMajorGb">34개 <i></i></button>
            <KSACheckBoxGroup
                ref="majorGbListRef"
                className="mr-md"
                name="searchMajorGbs"
                v-model="searchInput.searchMajorGbs"
                :options="data_majorGb" />
          </dd>
        </dl>
        <dl>
          <dt>아카데미 수료 강의</dt>
          <dd class="residence-selected">
            <button @click="showSearchLectureCompletionModal()"><i>+</i>강의 선택</button>
            <span v-for="(lecture, index) in searchLectureSelections" :key="lecture.key || `${lecture.lectName}-${index}`">
                    {{ lecture.lectName }}<i @click="deleteLecture(index)">삭제</i>
                </span>
          </dd>
        </dl>
        <div class="btn-wrap">
          <KSASecondaryButton class="gray_button" text="초기화" @click="onClickClearSearchInput" />
          <KSAPrimaryButton text="검색" @click="onClickSearch" />
        </div>
      </div>
    </div>
    <div class="list-top">
      <p>총 <span>{{ $number(totalCount) }}</span>명</p>
      <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
    </div>
    <div class="table-form board-mobile-vertical">
      <table>
        <tr>
          <th>번호</th>
          <th>이름</th>
          <th>관심 카테고리</th>
          <th>변경일</th>
          <th>이력서 보기</th>
          <th>채용 제안</th>
          <th>관심 인재</th>
        </tr>
        <tr v-for="resumeList in list">
          <td data-title="번호 : ">{{ resumeList.boardNo }}</td>
          <td data-title="이름 : ">{{ resumeList.userName }}</td>
          <td data-title="관심 카테고리 : ">{{ resumeList.interests }}</td>
          <td data-title="변경일 : ">{{ $yyyymmddHHmmss(resumeList.modifyDate) }}</td>
          <td v-if="resumeList.resOpenYn === 'N'" style="color: #b3b3b3;" data-title="이력서 보기 : ">
            이력서 보기
          </td>
          <td v-else data-title="이력서 보기 : ">
            <KSATextButton class="clickable resume" text="이력서 보기" @click="onClickViewResume(resumeList.resumeId, resumeList.resumeCorpYn, resumeList.resumeLikeYn)"/>
          </td>
          <td v-if="resumeList.resumeCorpYn === 1" style="color: #b3b3b3;" data-title="채용 제안 : ">
            채용 제안
          </td>
          <td v-else-if="resumeList.resOpenYn === 'N'" style="color: #b3b3b3;" data-title="채용 제안 : ">
            매칭 중단
          </td>
          <td v-else data-title="채용 제안 : ">
            <KSATextButton class="clickable resume" text="채용 제안" @click="onClickResumeCorpYn(resumeList.resumeId)"/>
          </td>
          <td v-if="resumeList.resumeLikeYn === 1" data-title="관심 인재 : ">
            <KSATextButton text="♥" @click="onClickResumeLikeYn(resumeList.resumeId, resumeList.resumeLikeYn)" class="red_button"></KSATextButton>
          </td>
          <td v-else data-title="관심 인재 : ">
            <KSATextButton text="♡" @click="onClickResumeLikeYn(resumeList.resumeId, resumeList.resumeLikeYn)" class="red_button"></KSATextButton>
          </td>
        </tr>
        <tr v-if="list.length === 0">
          <td colspan="7">검색 결과가 없습니다.</td>
        </tr>
      </table>
    </div>
    <Paginate
        v-if="list.length > 0"
        v-model="currentPage"
        :page-count="totalPages"
        :click-handler="onSelectPage"
    />
  </div>
  <MyPageResumeModal ref="userMatchingResumeModal"/>
  <SearchResidenceModal ref="searchResidenceModal" @submitSelection="handleSelectionSubmit"/>
  <SearchLectureCompletionModal ref="searchLectureCompletionModal" @submitSelection="handleLectureSelectionSubmit"/>
</template>

<style scoped lang="scss">
  @import "../../../../../assets/scss/theme";

  .tab {
    grid-template-columns: repeat(2, 1fr);
  }

  .clickable {
    cursor: pointer;
    &.resume {
      color: #3C72FF;
      &:hover {
        font-weight: 700;
        text-decoration: underline;
      }
    }
  }
</style>

